import * as type from '../../../actions/index.types';

const initialState = {
    loading: false,
    data: null,
    error: null,
    // operations = consolidated complaints + tasks dashboard (shared across
    // SocietyPortal and SocietyController)
    operations: null,
    operationsLoading: false,
    operationsError: null
};

export function DashboardReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_SOCIETY_DASHBOARD:
            return {
                ...state,
                loading: true,
                error: null
            };
        case type.GET_SOCIETY_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case type.GET_SOCIETY_DASHBOARD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action?.message || 'Failed to load dashboard'
            };

        case type.GET_OPERATIONS_DASHBOARD:
            return {
                ...state,
                operationsLoading: true,
                operationsError: null
            };
        case type.GET_OPERATIONS_DASHBOARD_SUCCESS:
            return {
                ...state,
                operationsLoading: false,
                operations: action.payload,
                operationsError: null
            };
        case type.GET_OPERATIONS_DASHBOARD_FAILURE:
            return {
                ...state,
                operationsLoading: false,
                operationsError: action?.message || 'Failed to load operations dashboard'
            };
        default:
            return state;
    }
}
